import { useEffect } from 'react';

export const useTitleOnMount = (title: string) => {
  useEffect(() => {
    window.parent.document.title = `${title} | Qantas Hotels`;
  }, [title]);
};
